import { createContext, useState, useMemo, useContext } from 'react'

const ProfileContext = createContext()

const Profile = ( {
  children
} ) => {
  const [ user, setUser ] = useState()
  const [ themeParams, setThemeParams ] = useState()

  useMemo( () => {
    if ( user )
      return

    let initData = window.Telegram.WebApp.initData

    if ( ! initData && process.env.REACT_APP_DEBUG )
      initData = 'query_id=AAHc1tseAAAAANzW2x5SohLs&user=%7B%22id%22%3A517723868%2C%22first_name%22%3A%228topolar%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22octopolar%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FMYAxTLZB0qJxpZS3DpExVZp4dd3F2e1aT-1it_HWa2s.svg%22%7D&auth_date=1768347084&signature=YJ63oKy--1ZGregnWPgT71MjRYA9_mGDQbH7KyBAVlZ6WaeLOCQ2z-H7DfY9yL3krj-ja_Vf97eTdkkXQtaPDg&hash=ab94290f4ad29712377871d7fa72a1f13bee4543af228dd0b96828786c11c433'

    const params = new URLSearchParams( initData )

    setUser( JSON.parse( params.get( 'user' ) ) )

    let theme = window.Telegram.WebApp.themeParams

    if ( Object.keys( theme ).length === 0 && process.env.REACT_APP_DEBUG ) {
      theme = {
        'tg-color-scheme': 'dark',
        'tg-theme-bg-color': '#212121',
        'tg-theme-button-color': '#8774e1',
        'tg-theme-button-text-color': '#ffffff',
        'tg-theme-hint-color': '#aaaaaa',
        'tg-theme-link-color': '#8774e1',
        'tg-theme-secondary-bg-color': '#181818',
        'tg-theme-text-color': '#ffffff',
        'tg-theme-header-bg-color': '#212121',
        'tg-theme-accent-text-color': '#8774e1',
        'tg-theme-section-bg-color': '#212121',
        'tg-theme-section-header-text-color': '#8774e1',
        'tg-theme-subtitle-text-color': '#aaaaaa',
        'tg-theme-destructive-text-color': '#ff595a',
        'tg-viewport-height': '100vh',
        'tg-viewport-stable-height': '100vh',
        'bg_color': '#212121',
        'button_color': '#8774e1',
        'button_text_color': '#ffffff',
        'hint_color': '#aaaaaa',
        'link_color': '#8774e1',
        'secondary_bg_color': '#181818',
        'text_color': '#ffffff',
        'header_bg_color': '#212121',
        'accent_text_color': '#8774e1',
        'section_bg_color': '#212121',
        'section_header_text_color': '#8774e1',
        'subtitle_text_color': '#aaaaaa',
        'destructive_text_color': '#ff595a'
      }
    }

    setThemeParams( theme )
  } )

  if ( ! user )
    return null

  return <ProfileContext.Provider
    value={ {
      user,
      themeParams
    } }
  >
    { children }
  </ProfileContext.Provider>
}

const withProfile = ( ComponentAlias ) => {
  return props => <ProfileContext.Consumer>
    { context => <ComponentAlias { ...props } withProfile={ context } /> }
  </ProfileContext.Consumer>
}

const useProfile = () => {
  const context = useContext( ProfileContext )

  if ( ! context )
    throw new Error( 'useProfile must be used with Profile provider' )

  return context
}

export {
  withProfile,
  ProfileContext,
  useProfile
}

export default Profile
